import React from 'react';
import {
  useTheme,
  PopoverContent as ChakraPopoverContent,
  PopoverHeader,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  Flex,
  Spacer,
} from '@chakra-ui/react';
import {TextA18} from '../../typography';

interface PopoverContentProps {
  header: string;
  body: JSX.Element;
  topRightElement?: JSX.Element;
}

const PopoverContent = ({header, body, topRightElement}: PopoverContentProps) => {
  const theme = useTheme();
  return (
    <ChakraPopoverContent _focus={{boxShadow: 'none'}} borderRadius="lg" border="none">
      <PopoverHeader
        bg={theme.colors.lightBlue}
        color="white"
        w="100%"
        borderTopRadius="md"
        fontWeight="semibold"
        border="0">
        {
          <Flex align="center" pr={8}>
            <TextA18>{header}</TextA18>
            {topRightElement && (
              <>
                <Spacer />
                {topRightElement}
              </>
            )}
          </Flex>
        }
      </PopoverHeader>
      <PopoverArrow
        bg={theme.colors.lightBlue}
        borderColor={theme.colors.lightBlue}
      />

      <PopoverCloseButton top={2} color="white" />
      <PopoverBody
        p={0}
        borderTop="none"
        borderWidth="1px"
        borderColor={theme.colors.lightBlue}
        borderBottomRadius="lg">
        {body}
      </PopoverBody>
    </ChakraPopoverContent>
  );
};

export default PopoverContent;
